"use strict";
/*
 * Created on 02 25 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ReleaseType_1 = require("../../release/model/ReleaseType");

var PriceStickersReportDTO_1 = require("../model/PriceStickersReportDTO");

var PriceStickersReportDTOConverter_1 = require("./PriceStickersReportDTOConverter");
/**
 * @author Jaroslav Sevcik
 */


var PriceStickersReportDTOConverterImpl =
/*#__PURE__*/
function (_PriceStickersReportD) {
  _inherits(PriceStickersReportDTOConverterImpl, _PriceStickersReportD);

  function PriceStickersReportDTOConverterImpl() {
    _classCallCheck(this, PriceStickersReportDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceStickersReportDTOConverterImpl).apply(this, arguments));
  }

  _createClass(PriceStickersReportDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new PriceStickersReportDTO_1.PriceStickersReportDTO(PriceStickersReportDTO_1.PriceStickersReportDTO.schema.rePriceType.valueOf(source.rePriceType && conversions.asEnum(source.rePriceType, ReleaseType_1.ReleaseType)), PriceStickersReportDTO_1.PriceStickersReportDTO.schema.priceListTypeId.valueOf(source.priceListTypeId), PriceStickersReportDTO_1.PriceStickersReportDTO.schema.priceCodeId.valueOf(source.priceCodeId), PriceStickersReportDTO_1.PriceStickersReportDTO.schema.currentYearRepricingCount.valueOf(source.currentYearRepricingCount), PriceStickersReportDTO_1.PriceStickersReportDTO.schema.lastTenWeeksRepricingCount.valueOf(source.lastTenWeeksRepricingCount), PriceStickersReportDTO_1.PriceStickersReportDTO.schema.currentWeekRepricingCount.valueOf(source.currentWeekRepricingCount), PriceStickersReportDTO_1.PriceStickersReportDTO.schema.lastYearSameWeekRepricingCount.valueOf(source.lastYearSameWeekRepricingCount), PriceStickersReportDTO_1.PriceStickersReportDTO.schema.nextWeekRepricingCount.valueOf(source.nextWeekRepricingCount));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      return {
        rePriceType: source.rePriceType,
        priceListTypeId: source.priceListTypeId,
        priceCodeId: source.priceCodeId,
        currentYearRepricingCount: source.currentYearRepricingCount,
        lastTenWeeksRepricingCount: source.lastTenWeeksRepricingCount,
        currentWeekRepricingCount: source.currentWeekRepricingCount,
        lastYearSameWeekRepricingCount: source.lastYearSameWeekRepricingCount,
        nextWeekRepricingCount: source.nextWeekRepricingCount
      };
    }
  }]);

  return PriceStickersReportDTOConverterImpl;
}(PriceStickersReportDTOConverter_1.PriceStickersReportDTOConverter);

exports.PriceStickersReportDTOConverterImpl = PriceStickersReportDTOConverterImpl;